import { Injectable, inject,  OnDestroy } from '@angular/core';
import { distinctUntilChanged, takeUntil, debounceTime, filter,tap, switchMap, delay, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, from, of, Subject } from 'rxjs';
import { User } from '../models/user.model';
import { ExampleApiService } from './exampleAPI.service';
import {
  MsalService,
  MsalModule,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Store } from '@ngrx/store';
import { environment } from '@environments/environment';
import { AuthActions } from '@store/actions/auth/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements  OnDestroy {

  private readonly store = inject(Store);
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private mAuthService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) {

   this.msalBroadcastService.msalSubject$
      .pipe(
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        // If we need more events they can be found here
        // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/events.md
        switch(result.eventType) {
            case EventType.LOGIN_START:
            break;
            case EventType.LOGIN_SUCCESS:
            this.store.dispatch(AuthActions.loginSuccess());
              break;
            case EventType.LOGIN_FAILURE:
            break;
            case EventType.ACQUIRE_TOKEN_START:
            break;
            case EventType.ACQUIRE_TOKEN_SUCCESS:
            break;
            case EventType.ACQUIRE_TOKEN_FAILURE:
            break;
            case EventType.LOGOUT_START:
            break;
            case EventType.LOGOUT_END:
            break;
            case EventType.LOGOUT_SUCCESS:
            break;
            case EventType.LOGOUT_FAILURE:
            break;
            case EventType.ACTIVE_ACCOUNT_CHANGED:
            break;
            case EventType.ACQUIRE_TOKEN_SUCCESS:
            break;
            case EventType.INITIALIZE_START:
              // this.store.dispatch(AuthActions.initializeStart());
            break;
            case EventType.INITIALIZE_END:
              this.store.dispatch(AuthActions.initializeEnd());

            break;
            case EventType.HANDLE_REDIRECT_START:
            // this.store.dispatch(AuthActions.redirectStart());
            break;
            case EventType.HANDLE_REDIRECT_END:
            this.store.dispatch(AuthActions.redirectEnd());
            break;
        }
      });


    this.mAuthService.handleRedirectObservable().subscribe({
      next: (authResult) => {
        // if (authResult && authResult.account) {
        //   this.mAuthService.instance.setActiveAccount(authResult.account);
        // }
      },
      error: (error) => console.error('Redirect handling error:', error),
    });


    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        if (!this.isAuthenticated()) {
          console.log('No active account. Redirecting to login.');
          this.mAuthService.loginRedirect({
            scopes: [...environment.msalConfig.auth.scopes],
            redirectStartPage: window.location.href,
          });
        } else {
          // this.setauthenticated();
          // this.checkAndSetActiveAccount();
        }
      });

  }

  // public loginSuccess$ = this.msalBroadcastService.msalSubject$.pipe(
  //   filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
  // )

  initializeAuth(): Observable<any> {
    return this.mAuthService.initialize();
  }

  setActiveAccount(): Observable<any> {
    var activeAccount  = null;
    activeAccount = this.mAuthService.instance.getActiveAccount();
    if (!activeAccount && this.mAuthService.instance.getAllAccounts().length > 0) {
      let accounts = this.mAuthService.instance.getAllAccounts();
      this.mAuthService.instance.setActiveAccount(accounts[0]);
      activeAccount = accounts[0];
      // console.log('Active account set to:', this.mAuthService.instance.getActiveAccount());
    }

    if (activeAccount)
    {
      // return user as observable
      return of(activeAccount);
    }
    else
    {
      throw new Error("Can't set Active Account");
    }
  }

  getAzureToken(account: any): Observable<string> {
    const webApiScopes =  [`${environment.msalConfig.auth.apiScope}`];

      var activeAccount = this.mAuthService.instance.getActiveAccount();
      var request = {
                scopes: webApiScopes,
      };

    return from(this.mAuthService.acquireTokenSilent(request)).pipe(
      map((data) => {
        return data.accessToken
      })
    )
  }

  isAuthenticated(): boolean {
   return this.mAuthService.instance.getAllAccounts().length > 0
  }

  loginRedirect(redirectStartPage?: string): void {
      this.mAuthService.loginRedirect({
        scopes: [...environment.msalConfig.auth.scopes],
        ...(redirectStartPage && { redirectStartPage }),
      });
  }

  logout(): Observable<any> {
    this.mAuthService.logoutRedirect();
    return of();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }


}
